<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import WootModal from 'dashboard/components/Modal.vue';

const props = defineProps({ appointment: { type: Object, required: true } });
const emit = defineEmits(['close']);
const store = useStore();
const { t } = useI18n();

const show = ref(true);

const startsAt = new Date(props.appointment.starts_at);
const durationMin = computed(() =>
  Math.round(
    (new Date(props.appointment.ends_at) -
      new Date(props.appointment.starts_at)) /
      60000
  )
);

const newDate = ref(startsAt.toISOString().slice(0, 10));
const newTime = ref(startsAt.toTimeString().slice(0, 5));
const newDuration = ref(durationMin.value);
const saving = ref(false);

const close = () => {
  show.value = false;
  emit('close');
};

const save = async () => {
  saving.value = true;
  try {
    const iso = new Date(`${newDate.value}T${newTime.value}:00`).toISOString();
    await store.dispatch('painelAppointments/reschedule', {
      id: props.appointment.id,
      payload: { starts_at: iso, duration_minutes: newDuration.value },
    });
    close();
  } finally {
    saving.value = false;
  }
};
</script>

<template>
  <WootModal v-model:show="show" @close="close">
    <div class="p-6">
      <h2 class="mb-4 text-lg font-semibold">
        {{ t('PAINEL.APPOINTMENTS.RESCHEDULE') }}
      </h2>
      <p class="mb-4 text-sm text-n-slate-11">
        {{ t('PAINEL.APPOINTMENTS.CURRENT_AT') }}
        {{ new Date(appointment.starts_at).toLocaleString('pt-BR') }}
      </p>
      <div class="grid grid-cols-2 gap-3">
        <label class="text-sm">
          {{ t('PAINEL.APPOINTMENTS.NEW_DATE') }}
          <input
            v-model="newDate"
            type="date"
            class="mt-1 w-full rounded border border-n-strong px-2 py-1"
          />
        </label>
        <label class="text-sm">
          {{ t('PAINEL.APPOINTMENTS.NEW_TIME') }}
          <input
            v-model="newTime"
            type="time"
            class="mt-1 w-full rounded border border-n-strong px-2 py-1"
          />
        </label>
        <label class="col-span-2 text-sm">
          {{ t('PAINEL.APPOINTMENTS.DURATION_MIN') }}
          <input
            v-model.number="newDuration"
            type="number"
            min="5"
            step="5"
            class="mt-1 w-full rounded border border-n-strong px-2 py-1"
          />
        </label>
      </div>

      <div class="mt-6 flex justify-end gap-2">
        <button class="rounded bg-n-slate-3 px-3 py-1" @click="close">
          {{ t('PAINEL.APPOINTMENTS.CANCEL') }}
        </button>
        <button
          class="rounded bg-n-teal-9 px-3 py-1 text-white disabled:opacity-50"
          :disabled="saving"
          @click="save"
        >
          {{ t('PAINEL.APPOINTMENTS.RESCHEDULE_SUBMIT') }}
        </button>
      </div>
    </div>
  </WootModal>
</template>
